import axios from 'axios'
import getHeaders from '../helpers/headers'
import config from '../../constants/endpoints.js'
const {
  endpoints: { contentTexts: url },
} = config

const get = (query) =>
  axios({
    url,
    method: 'get',
    headers: getHeaders(),
    params: query || undefined,
  })

const getTexts = ({ platform, type, tag }) =>
  axios({
    url: `${url}/${platform}/${type}`,
    method: 'get',
    headers: getHeaders(true),
    ...(tag ? { params: { tag } } : {}),
  })

const postText = ({ platform, type }, data) =>
  axios({
    url: `${url}/${platform}/${type}`,
    method: 'post',
    headers: getHeaders(true),
    data,
  })

const deleteText = ({ platform, type, tag }) =>
  axios({
    url: `${url}/${platform}/${type}`,
    method: 'delete',
    headers: getHeaders(true),
    ...(tag ? { params: { tag } } : {}),
  })

const getRichText = (tag) =>
  axios({
    url: `${url}/bot-template`,
    method: 'get',
    headers: getHeaders(true),
    ...(tag ? { params: { tag } } : {}),
  })

const postRichText = (tag, data, { time, unit }) =>
  axios({
    url: `${url}/bot-template`,
    method: 'post',
    headers: getHeaders(true),
    data: {
      tag,
      time,
      unit,
      _id: data._id,
      text: {
        default: data.message || {}
      }
    }
  })

export default { get, getTexts, postText, deleteText, getRichText, postRichText }
